
.col {
  flex-grow: 5;
  flex-basis: 0;
  width: 100%;
}

.textarea {
  height: 6em;
}

.error {
  border: 1px solid var(--red) !important;
  outline-color: var(--red) !important;
}
